module.exports = __webpack_public_path__ + "img/iconPen.70eb80ba.png";